import { motion } from "framer-motion";
import { Check, Hourglass } from "lucide-react";
import { MEETINGS } from "@/data";

export default function Calendario() {
    return (
        <div data-testid="calendar-list">
            {MEETINGS.map((m, i) => {
                const isNext = m.status === "next";
                return (
                    <motion.div
                        key={`${m.day}-${m.month}-${i}`}
                        className={`meeting-row ${isNext ? "meeting-next" : ""}`}
                        initial={{ opacity: 0, x: -24 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: Math.min(i * 0.05, 0.3) }}
                        data-testid={`meeting-row-${i}`}
                    >
                        <div className={`date-box ${isNext ? "next" : ""}`} data-testid={`meeting-date-${i}`}>
                            <span className="day">{m.day}</span>
                            <span className="month">{m.month}</span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="f-title text-base sm:text-xl text-[#3f2a12] leading-snug">{m.title}</h3>
                            <p className="f-body italic text-[#6d5638] mt-1 text-sm sm:text-base">
                                {m.host ? `con ${m.host}` : `di ${m.author}`}
                            </p>
                        </div>
                        <span className={`badge ${isNext ? "badge-next" : "badge-done"}`} data-testid={`meeting-badge-${i}`}>
                            {isNext ? <Hourglass size={12} /> : <Check size={12} />}
                            {isNext ? "Prossimo" : "Svolto"}
                        </span>
                    </motion.div>
                );
            })}
        </div>
    );
}
